module.exports = __webpack_public_path__ + "media/images/illustrations/undraw_connected_world-a9c0c8be9968e606fd2b54f2bb331320.svg";